import { render } from "./goldView.vue?vue&type=template&id=027f3f46&scoped=true"
import script from "./goldView.vue?vue&type=script&lang=js"
export * from "./goldView.vue?vue&type=script&lang=js"

import "./goldView.vue?vue&type=style&index=0&id=027f3f46&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027f3f46"]])

export default __exports__